import styled from 'styled-components';
import { IconButton } from '@chegg-ui/button';
export var Wrapper = styled.div.withConfig({
  componentId: "sc-180vej1-0"
})(["width:100%;display:flex;column-gap:10px;flex-wrap:wrap;.function{flex-basis:100%;& > div span{text-transform:capitalize;}& ul > li{text-transform:capitalize;}}.first,.middle,.last{flex:1 1 40%;}.suffix{flex:1 1 calc(40% - 34px);}"]);
export var DeleteContributorButton = styled(IconButton).withConfig({
  componentId: "sc-180vej1-1"
})(["padding:0px;"]);